





















































import Vue, { VueConstructor } from 'vue';
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';

import LClusterMarker from 'vue2-leaflet-markercluster';
import Leaflet, { Control } from 'leaflet';
import 'leaflet.locatecontrol';
import { debounce } from 'underscore';
import { LatLng, LatLngBounds, MapOptions, MechanicInstallation, Nullable } from '@/types';

export default Vue.extend({
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LClusterMarker,
  },

  data() {
    return {
      control: null as Nullable<Control.Locate>,
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      selected: null as Nullable<MechanicInstallation>,
    };
  },

  computed: {
    mapOptions(): MapOptions {
      return this.$store.state.maps.options;
    },

    zoom(): number {
      return this.mapOptions.zoom;
    },

    bounds(): LatLngBounds | undefined {
      return this.mapOptions.bounds;
    },

    center(): LatLng {
      return this.mapOptions.center;
    },

    searchTerm: {
      get(): string {
        return this.$store.state.maps.searchTerm;
      },

      set(val: string) {
        // If an item from the dropdown is selected, do NOT use this as input for an new search query.
        if (this.selected && this.selected.address === val) {
          return;
        }

        if (val !== this.searchTerm) {
          this.search(val);
        }

        this.$store.commit('maps/set:searchTerm', val);
      },
    },

    loading(): boolean {
      return this.$store.getters['maps/isPending'];
    },

    coordinates() {
      return (installation: MechanicInstallation): [number, number] => [
        installation.lat,
        installation.lon,
      ];
    },

    installations(): MechanicInstallation[] {
      return this.$store.state.maps.installations;
    },
  },

  watch: {
    selected(current) {
      if (!current || !current.lat || !current.lon) {
        return;
      }

      this.update({ center: { lat: current.lat, lng: current.lon }, zoom: 16 });
    },
  },

  mounted() {
    this.search(this.searchTerm);

    if (!this.control) {
      const map = this.$refs.map as LMap;

      this.control = Leaflet.control
        .locate({
          setView: true,
          locateOptions: {
            maxZoom: 14,
            enableHighAccuracy: true,
            setView: true,
            watch: true,
          },
        })
        .addTo(map.mapObject);
    }
  },

  methods: {
    zoomUpdated(zoom: number) {
      this.update({ zoom });
    },

    centerUpdated(center: LatLng) {
      this.update({ center });
    },

    boundsUpdated(bounds: LatLngBounds) {
      this.update({ bounds });
    },

    update({ zoom, center, bounds }: { zoom?: number; center?: LatLng; bounds?: LatLngBounds }) {
      this.$store.commit('maps/set:options', {
        zoom: zoom ?? this.zoom,
        center: center ?? this.center,
        bounds: bounds ?? this.bounds,
      });
    },

    search: debounce(function search(this: Vue, term: string) {
      this.$store.dispatch('maps/search', term);
    }, 500),
  },
});
